import type { Host } from '@interfaces/host.interface';

import { mockDb } from '../mock-db';

/** A fresh copy per call, as an HTTP body is, so a re-read after a settings save is a new value. */
export function getHostMock(): Host & { externalCodeName?: string } {
  return { ...mockDb.getHost() };
}

export function getHostByIdMock(id: string): Host {
  return { ...mockDb.host, id };
}

export function updateHostMock(id: string, data: Partial<Host>): Host {
  return { ...mockDb.host, id, ...data };
}
